import { Project } from "../../types";

export const projectData: Project[] = [
    { 
        id: '1', 
        title: "Audio Engineering", 
        image: "/images/project/project1.avif",
        altimage: "/images/project/altproject1.avif",
        moreInfo: [
            {
                Industry: "Audio Production",
                Client: "Adiloriuse",
                Service: "Audio Engineering",
                Date: "Built & Opened 2022",
            },
        ],
        content: [
            {
                type: 'section',
                blocks: [
                    { type: "heading", level: 3, mb: 5, text: "Audio Engineering"},
                    { type: "paragraph", text: "At the Broadcast Studio, we bring stories to life through sound. Our experienced audio engineering team—led by industry veteran Clay Jones—offers expert recording, mixing, and mastering services tailored to a wide range of projects, including podcasts, audiobooks, film, music, and live events." },
                    { type: "paragraph", text: "Whether you're an author, artist, educator, or entrepreneur, we provide a creative and technically precise environment to help your voice be heard—literally. From crystal-clear dialogue capture to rich sound design and post-production polish, we deliver professional-grade audio that meets broadcast standards and exceeds expectations." },
                    { type: "paragraph", text: "Our studio is equipped with state-of-the-art tools and a comfortable, acoustically treated space designed to support focused, high-quality production. We also offer remote session capabilities, voiceover direction, ADR, and project consultation to fit your needs." },
                    { type: "paragraph", style: 'b', text: "Bring us your story, and we’ll help you make it unforgettable." },
                ],
            }, 
        ],
    },
    { 
        id: '2', 
        title: "Video Production", 
        image: "/images/project/project2.avif",
        altimage: "/images/project/altproject2.avif",
        moreInfo: [
            {
                Industry: "Design",
                Client: "Competarios",
                Service: "Illustration",
                Date: "July 2024",
            },
        ],
        content: [
            {
                type: 'section',
                blocks: [
                    { type: "heading", level: 3, mb: 5, text: "Video Production"},
                    { type: "paragraph", text: "Bring your vision to life with full-service video production tailored to your message and audience. Whether you're telling a story, promoting a brand, documenting an event, or creating content for digital platforms, we’re here to help every step of the way—from concept to final cut. Our team offers professional cinematography, sound design, editing, and direction, all within a studio built to support creativity and collaboration. Let’s capture something powerful together." },
                ],
            },
        ],
    },
    { 
        id: '3', 
        title: "Branding", 
        image: "/images/project/project3.avif" ,
        altimage: "/images/project/altproject3.avif",
        moreInfo: [
            {
                Industry: "Architecture",
                Client: "Implementto",
                Service: "Graphic Design",
                Date: "June 2024",
            },
        ],
        content: [
            {
                type: 'section',
                blocks: [
                    { type: "heading", level: 3, mb: 5, text: "Branding"},
                    { type: "paragraph", text: "An emblem is a graphical mark, stamp, or emblem utilized to promote and encourage broad awareness and acceptance. It may present as a metaphorical or imaginative figure or include the term it represents, as illustrated in a logotype." },
                ],
            },
        ],
    },
    { 
        id: '4', 
        title: "Experimental", 
        image: "/images/project/project4.avif",
        altimage: "/images/project/altproject4.avif",
        moreInfo: [
            {
                Industry: "Application",
                Client: "Fabusocci",
                Service: "Design",
                Date: "May 2024",
            },
        ],
        content: [
            {
                type: 'section',
                blocks: [
                    { type: "heading", level: 3, mb: 5, text: "Experimental"},
                    { type: "paragraph", text: "A logo represents a graphical emblem, stamp, or symbol employed to amplify and promote communal identification and acceptance. This could embody a reflective or creative design, or embody the term it represents, as seen in a logotype." },
                ],
            },
        ],
    },
    { 
        id: '5', 
        title: "Podcast Subscription Plans", 
        image: "/images/project/project5.avif",
        altimage: "/images/project/altproject5.avif",
        moreInfo: [
            {
                Industry: "Creative",
                Client: "Vestibullum",
                Service: "Audio Production",
                Date: "April 2024",
            },
        ],
        content: [
            {
                type: 'section',
                blocks: [
                    { type: "heading", level: 3, mb: 5, text: "Podcast Subscription Plans"},
                    { type: "paragraph", text: "Consistent, High-Quality Podcast Production—Made Easy" },
                    { type: "paragraph", text: "Whether you're launching your first show or scaling a growing series, our podcast subscription packages are designed to take the guesswork out of production. With flexible monthly plans, professional audio engineering, and dedicated support, you get everything you need to sound your best—every time you hit record." },
                    { type: "paragraph", text: "At the Broadcast Studio, we make it easy to stay on schedule, elevate your content, and grow your audience with confidence. Record in a comfortable, acoustically-treated space with expert guidance, fast turnaround, and studio-quality sound that sets your show apart." },
                    { type: "paragraph", style: 'b', text: "Choose the plan that fits your goals—and let’s build something great, one episode at a time." },
                ],
            },
        ], 
    },
    { 
        id: '6', 
        title: "Creative", 
        image: "/images/project/project6.avif",
        altimage: "/images/project/altproject6.avif",
        moreInfo: [
            {
                Industry: "Web Design",
                Client: "Corperrsum",
                Service: "Creative",
                Date: "March 2024",
            },
        ],
        content: [
            {
                type: 'section',
                blocks: [
                    { type: "heading", level: 3, mb: 5, text: "Creative"},
                    { type: "paragraph", text: "In the sphere of visual aesthetic, 'shape' relates to a designated, bi-dimensional space illustrated through lines, colors, or palpable textures, or a zone outlined with shapes such as trapezoids, rectangles, and spheres." },
                ],
            },
        ], 
    },
];